import { ArrowBackIosNew } from '@project-lary/react-material-symbols';
import { useGetETSTicketsInfiniteQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import {
  ETS_TICKETS_CRAFTSMEN_QUERY,
  type FetchETSTicketsResponseData,
} from 'gcs-common/clients/api/entities/tickets/tickets-api-helpers';
import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { getSidebarCollapsed } from 'gcs-common/slices/uiState/uiStateSelectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import InfiniteScroller from '../../../components/InfiniteScroller/InfiniteScroller';
import TicketItemPlaceHolder from '../TicketItemPlaceHolder/TicketItemPlaceHolder';
import TicketItemSkeleton from '../TicketItemSkeleton/TicketItemSkeleton';
import TicketListItem from '../TicketListItem/TicketListItem';

interface TicketsListsHeaderProps {
  returnToChat: VoidFunction;
  isSidebarCollapsed: boolean;
}

const TicketsListsHeader = (props: TicketsListsHeaderProps) => {
  const { returnToChat, isSidebarCollapsed } = props;

  return (
    <div className="flex items-center border-0 border-neutral-3 border-b border-solid p-4 pl-2">
      <IconButton
        Icon={ArrowBackIosNew}
        iconSize="size-6"
        className="cursor-pointer"
        size="m"
        variant="ghost_neutral"
        onClick={() => returnToChat()}
      />

      <div className="flex flex-1 justify-center">
        <p className="text-base">{!isSidebarCollapsed ? 'Ersatzteilanfragen' : 'ETS'}</p>
      </div>
    </div>
  );
};

const TicketsLists = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isNewTicket = location.pathname === CHAT_ROUTES.NEW_TICKET;

  const selectedChannelId = useSelector(getSelectedChannelId);
  const isSidebarCollapsed = useSelector(getSidebarCollapsed);

  const { data, isPending, hasNextPage, fetchNextPage, isFetchingNextPage, isFetching } = useGetETSTicketsInfiniteQuery(
    {
      query: ETS_TICKETS_CRAFTSMEN_QUERY,
    },
  );

  const tickets = data || [];

  const returnToChat = () => {
    navigate(CHAT_ROUTES.CHANNEL(selectedChannelId));
  };
  if (isPending) {
    return (
      <>
        <TicketsListsHeader returnToChat={returnToChat} isSidebarCollapsed={isSidebarCollapsed} />
        <TicketItemSkeleton />
      </>
    );
  }
  return (
    <div className="flex min-h-0 flex-grow flex-col">
      {/* TODO: Once the sidebar is unified apply this new components */}
      {/*<div className="mt-4 flex flex-col justify-center gap-4 border-0 border-neutral-3 border-b border-solid px-4 pb-4">
        {/* <SearchBar onSearchText={searchTicket} />
        <HouseSwitcher /> 
      </div>*/}
      <div className="flex-shrink-0">
        <TicketsListsHeader returnToChat={returnToChat} isSidebarCollapsed={isSidebarCollapsed} />
        {isNewTicket && <TicketItemPlaceHolder />}
      </div>
      <InfiniteScroller<FetchETSTicketsResponseData['data'][number]>
        isFetchingNextPage={isFetchingNextPage}
        isFetching={isFetching}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        rowRenderer={(ticket, _index) => {
          return (
            <TicketListItem
              id={ticket.id}
              key={ticket.id}
              status={ticket.status}
              title={ticket.title}
              previewImageUrl={ticket.previewImageUrl}
              createdAt={ticket.createdAt}
              updatedAt={ticket.jiraLastSyncedAt}
              hasNotifications={ticket.hasNotifications ?? false}
            />
          );
        }}
        allRows={tickets}
        estimateSize={65}
        onEmpty={() => (
          <div className="flex h-full flex-col items-center justify-center">
            <div>
              <IconComponent Icon={ICON.ETS} size={ICON_SIZE.XX_LARGE} className="text-neutral-4" />
            </div>
            <div>
              <p className="text-lg text-neutral-9">Keine Ersatzteilanfragen</p>
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default TicketsLists;
